import { render, staticRenderFns } from "./refundsProfile.vue?vue&type=template&id=3712ba22&scoped=true&"
import script from "./refundsProfile.vue?vue&type=script&lang=js&"
export * from "./refundsProfile.vue?vue&type=script&lang=js&"
import style0 from "./refundsProfile.vue?vue&type=style&index=0&id=3712ba22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3712ba22",
  null
  
)

export default component.exports